import React, { useState } from 'react';
import Header from './components/Header';
import Hero from './components/Hero';
import TrainingGoals from './components/TrainingGoals';
import Benefits from './components/Benefits';
import NutritionSection from './components/NutritionSection';
import FoodScanner from './components/FoodScanner';
import FinalCTA from './components/FinalCTA';
import Footer from './components/Footer';

function App() {
  const [lang, setLang] = useState('de');

  const toggleLang = () => setLang(lang === 'de' ? 'en' : 'de');

  return (
    <div className="min-h-screen" style={{ backgroundColor: '#0f1117', color: '#ffffff' }}>
      <Header lang={lang} onToggleLang={toggleLang} />
      <Hero lang={lang} />
      <TrainingGoals lang={lang} />
      <Benefits lang={lang} />
      <NutritionSection lang={lang} />
      <FoodScanner lang={lang} />
      <FinalCTA lang={lang} />
      <Footer lang={lang} />
    </div>
  );
}

export default App;
